export interface InsidePage {
  id: string
  src: string
  alt: string
  caption: string
}

export const insidePages: InsidePage[] = [
  {
    id: 'preliminary-fuel-inspection',
    src: 'https://cdn.magicpatterns.com/uploads/s9svRnEHMuLdtcP6EpSmTP/Captura-de-pantalla-2026-09-18-a-la_s_-5.50.28_p.-m..webp',
    alt: 'Preliminary fuel system inspection checklist with 12 visual inspection points, clogged filter, damaged supply-line connector and water separator examples',
    caption: 'Preliminary Fuel System Inspection',
  },
  {
    id: 'high-pressure-pump',
    src: 'https://cdn.magicpatterns.com/uploads/4VB5tJvAjfUGGG59jvGVAF/Captura-de-pantalla-2026-09-18-a-la_s_-5.51.07_p.-m..webp',
    alt: 'High-pressure pump function and diagnostic role, cutaway diagram with low rail pressure checklist and cause paths',
    caption: 'High-Pressure Pump — Function & Diagnostic Role',
  },
  {
    id: 'fuel-quality',
    src: 'https://cdn.magicpatterns.com/uploads/w2nvQt5bixzEZYARTzk7v8/Captura-de-pantalla-2026-09-18-a-la_s_-5.50.50_p.-m..webp',
    alt: 'Fuel quality and contamination diagnostics comparing clean diesel, water contamination, particulate debris, incorrect fuel type and microbial growth samples',
    caption: 'Fuel Quality & Contamination Diagnostics',
  },
  {
    id: 'case-study-hard-start',
    src: 'https://cdn.magicpatterns.com/uploads/kBFQtgCBfAAStAGWA3bnug/Captura-de-pantalla-2026-09-18-a-la_s_-5.52.06_p.-m..webp',
    alt: 'Case study 3, hard start after fuel system service, with complaint, inspection, diagnostic evidence, repair, verification and before/after flow diagrams',
    caption: 'Case Study — Hard Start After Fuel System Service',
  },
  {
    id: 'injector-electrical',
    src: 'https://cdn.magicpatterns.com/uploads/iNF2PHBh8vY2PvvqBWiq1Y/Captura-de-pantalla-2026-09-18-a-la_s_-5.51.35_p.-m..webp',
    alt: 'Injector electrical diagnostics diagram showing ECM driver circuit, harness routing, connector pins, solenoid and piezo injector test points',
    caption: 'Injector Electrical Diagnostics',
  },
]
